import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import {
  LinkedInWhite,
  InstagramWhite,
  WordPressWhite,
  GoHighLevelWhite,
  FacebookWhite,
  TwitterWhite,
  YouTubeWhite,
  TikTokWhite,
  MailchimpWhite,
  GoogleWhite,
  GoogleDriveWhite,
  MetaAdsWhite,
} from 'blaze-ui/icons/integrations'

export interface IntegrationConfig {
  provider: ExternalIntegrationEnum
  displayName: string
  icon: React.ComponentType<{ size?: number }>
  isImplemented: boolean
}

export const INTEGRATION_CONFIGS: Record<string, IntegrationConfig> = {
  Instagram: {
    provider: ExternalIntegrationEnum.Instagram,
    displayName: 'Instagram',
    icon: InstagramWhite,
    isImplemented: true,
  },
  Facebook: {
    provider: ExternalIntegrationEnum.Facebook,
    displayName: 'Facebook',
    icon: FacebookWhite,
    isImplemented: true,
  },
  LinkedIn: {
    provider: ExternalIntegrationEnum.LinkedIn,
    displayName: 'LinkedIn',
    icon: LinkedInWhite,
    isImplemented: true,
  },
  Twitter: {
    provider: ExternalIntegrationEnum.X,
    displayName: 'X / Twitter',
    icon: TwitterWhite,
    isImplemented: true,
  },
  YouTube: {
    provider: ExternalIntegrationEnum.YouTube,
    displayName: 'YouTube',
    icon: YouTubeWhite,
    isImplemented: true,
  },
  Email: {
    provider: ExternalIntegrationEnum.Mailchimp,
    displayName: 'Mailchimp',
    icon: MailchimpWhite,
    isImplemented: true,
  },
  SEO: {
    provider: ExternalIntegrationEnum.WordPress,
    displayName: 'WordPress',
    icon: WordPressWhite,
    isImplemented: true,
  },
  TikTok: {
    provider: ExternalIntegrationEnum.TikTok,
    displayName: 'TikTok',
    icon: TikTokWhite,
    isImplemented: true,
  },
  GoogleDrive: {
    provider: ExternalIntegrationEnum.GoogleDrive,
    displayName: 'Google Drive',
    icon: GoogleDriveWhite,
    isImplemented: true,
  },
  // Future integrations - not yet implemented but coming soon
  MetaAds: {
    provider: ExternalIntegrationEnum.MetaAds,
    displayName: 'Meta',
    icon: MetaAdsWhite,
    isImplemented: false,
  },
  Google: {
    provider: ExternalIntegrationEnum.Google,
    displayName: 'Google Analytics',
    icon: GoogleWhite,
    isImplemented: false,
  },
  GoogleAds: {
    provider: ExternalIntegrationEnum.GoogleAds,
    displayName: 'Google Ads',
    icon: GoogleWhite,
    isImplemented: true,
  },
  // Blog platforms as standalone integrations
  WordPress: {
    provider: ExternalIntegrationEnum.WordPress,
    displayName: 'WordPress',
    icon: WordPressWhite,
    isImplemented: true,
  },
  GoHighLevel: {
    provider: ExternalIntegrationEnum.GoHighLevel,
    displayName: 'GoHighLevel',
    icon: GoHighLevelWhite,
    isImplemented: true,
  },
}

export const SEO_PLATFORM_CONFIGS: Record<string, IntegrationConfig> = {
  [ExternalIntegrationEnum.WordPress]: {
    provider: ExternalIntegrationEnum.WordPress,
    displayName: 'WordPress',
    icon: WordPressWhite,
    isImplemented: true,
  },
  [ExternalIntegrationEnum.GoHighLevel]: {
    provider: ExternalIntegrationEnum.GoHighLevel,
    displayName: 'GoHighLevel',
    icon: GoHighLevelWhite,
    isImplemented: true,
  },
}

export const INTEGRATION_PRIORITY_ORDER = [
  'LinkedIn',
  'Instagram',
  'Facebook',
  'Twitter',
  'TikTok',
  'YouTube',
  'WordPress',
  'GoHighLevel',
  'Email',
] as const

export const getIntegrationConfig = (
  integration: string,
  selectedBlogPlatform?: ExternalIntegrationEnum | 'generic' | null,
): IntegrationConfig | null => {
  if (integration === 'SEO') {
    if (selectedBlogPlatform === 'generic') return null
    const platform = selectedBlogPlatform || ExternalIntegrationEnum.WordPress
    return SEO_PLATFORM_CONFIGS[platform] || INTEGRATION_CONFIGS['SEO']
  }

  return INTEGRATION_CONFIGS[integration] || null
}

export const getProviderForTactic = (
  integration: string,
  selectedBlogPlatform?: ExternalIntegrationEnum | 'generic' | null,
): ExternalIntegrationEnum | null => {
  const config = getIntegrationConfig(integration, selectedBlogPlatform)
  return config?.provider || null
}
